import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";
import getSymbolFromCurrency from "currency-symbol-map";

import * as actions from "../../../../actions/currencyActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as settings from "../../../../constants/settings";

import * as validationHelper from "../../../../helpers/validationHelper";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import help from "../../../../resources/img/svgicons/help.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";

class EditCurrencyModal extends Component {
    constructor(props) {
        super(props);

        let currencyCodes = require("currency-codes");
        if (this.props.params?.currency) {
            this.state = {
                newCurrencyName: String(this.props.params.currency.name),
                newCurrencyCode: String(this.props.params.currency.code),
                newCurrencySymbol: String(this.props.params.currency.symbol),
                newCurrencyRate: String(this.props.params.currency.rate),
                newCurrencyRounding: String(this.props.params.currency.rounding),
                currencyCodes: currencyCodes.codes()
            };
        } else {
            this.state = {
                newCurrencyName: "",
                newCurrencyCode: settings.DEFAULT_CURRENCY_CODE,
                newCurrencySymbol: getSymbolFromCurrency(settings.DEFAULT_CURRENCY_CODE),
                newCurrencyRate: "",
                newCurrencyRounding: "0.01",
                currencyCodes: currencyCodes.codes()
            };
        }
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseEditCurrencyModalAction();
    };

    handleFocus = (event) => {
        event.target.select();
    };

    handleNewCurrencyNameChange = (event) => {
        this.setState({
            newCurrencyName: event.target.value
        });
    };

    handleNewCurrencyCodeChange = (event) => {
        let currencySymbol = getSymbolFromCurrency(event.target.value);

        this.setState({
            newCurrencyCode: event.target.value,
            newCurrencySymbol: currencySymbol ?? event.target.value
        });
    };

    handleNewCurrencyRateChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                newCurrencyRate: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleNewCurrencyRoundingChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                newCurrencyRounding: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    newCurrencyFilled = () => {
        return (
            this.state.newCurrencyName.trim().length > 0 &&
            this.state.newCurrencyCode.length > 0 &&
            this.state.newCurrencySymbol.length > 0 &&
            this.state.newCurrencyRate.trim().length > 0 &&
            this.state.newCurrencyRounding.trim().length > 0
        );
    };

    handleEditButtonClick = () => {
        if (this.props.params !== null) {
            if (this.newCurrencyFilled()) {
                this.props.dispatchEditCurrency(
                    this.props.params.currency.id,
                    this.state.newCurrencyName.trim(),
                    this.state.newCurrencyCode,
                    this.state.newCurrencySymbol,
                    Number(this.state.newCurrencyRate),
                    Number(this.state.newCurrencyRounding),
                    this.props.params.currency.visible
                );
            }
        } else {
            if (this.newCurrencyFilled()) {
                this.props.dispatchAddCurrency(
                    this.state.newCurrencyName.trim(),
                    this.state.newCurrencyCode.trim(),
                    this.state.newCurrencySymbol,
                    Number(this.state.newCurrencyRate),
                    Number(this.state.newCurrencyRounding)
                );
            }
        }
    };

    getHintTooltip = (title) => {
        if (this.props.activeHelp) {
            return (
                <ReactSVG
                    src={help}
                    alt="help"
                    data-text={translate(title)}
                    className="force-square size20x20 fit-image fill-primary pull-left margin-right-10"
                    onMouseEnter={tooltipHelper.createTooltip}
                />
            );
        }

        return "";
    };

    getCodeOptions = () => {
        return this.state.currencyCodes.map((code) => {
            return (
                <option key={code} value={code}>
                    {code}
                </option>
            );
        });
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleEditButtonClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                    disabled={!this.newCurrencyFilled()}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        {this.getHintTooltip("help.priceSettings.currencyNameNew")}
                        *<Translate value="currencySettings.namePlaceholder" />:
                    </div>
                    <Input
                        className="primary-input col-8"
                        type="text"
                        value={this.state.newCurrencyName}
                        onChange={this.handleNewCurrencyNameChange}
                        onFocus={this.handleFocus}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        {this.getHintTooltip("help.priceSettings.currencyCodeNew")}
                        <Translate value="currencySettings.codePlaceholder" />:
                    </div>
                    <select
                        className="primary-select col-8"
                        value={this.state.newCurrencyCode}
                        onChange={this.handleNewCurrencyCodeChange}
                    >
                        {this.getCodeOptions()}
                    </select>
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        {this.getHintTooltip("help.priceSettings.currencySymbolNew")}
                        <Translate value="currencySettings.symbolPlaceholder" />:
                    </div>
                    <Input
                        className="primary-input col-8"
                        type="text"
                        value={this.state.newCurrencySymbol}
                        readOnly={true}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        {this.getHintTooltip("help.priceSettings.currencyRateNew")}
                        *<Translate value="currencySettings.ratePlaceholder" />:
                    </div>
                    <Input
                        className="primary-input col-8"
                        type="text"
                        value={this.state.newCurrencyRate}
                        onChange={this.handleNewCurrencyRateChange}
                        onFocus={this.handleFocus}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        {this.getHintTooltip("help.priceSettings.currencyRoundingNew")}
                        *<Translate value="currencySettings.setRounding" />:
                    </div>
                    <Input
                        className="primary-input col-8"
                        type="text"
                        value={this.state.newCurrencyRounding}
                        onChange={this.handleNewCurrencyRoundingChange}
                        onFocus={this.handleFocus}
                    />
                </div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.currency" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeHelp: store.navigation.activeHelp
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseEditCurrencyModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_CURRENCY_MODAL));
        },
        dispatchAddCurrency: (name, code, symbol, rate, rounding) => {
            dispatch(actions.addCurrency(name, code, symbol, rate, rounding));
        },
        dispatchEditCurrency: (id, name, code, symbol, rate, rounding, visible) => {
            dispatch(actions.editCurrency(id, name, code, symbol, rate, rounding, visible));
        }
    };
};

export default EditCurrencyModal = connect(mapStoreToProps, mapDispatchToProps)(EditCurrencyModal);
